export const ROLES = {
    ADMIN: 'admin',
    MANAGER: 'manager',
    WAREHOUSEMAN: 'warehouseman',
};

export const SECTIONS = {
    PRICE_LIST: 'price-list',
    IMPORT_ORDERS: 'import-orders',
    BLACK_LIST: 'black-list',
    ORDERS_PAGE: 'orders-page',
    REFUND_REQUESTS_SUPPLIER: 'refund-requests-supplier',
    REFUND_REQUESTS_BUYER: 'refund-requests-buyer',
    TRANSACTIONS: 'transactions',
    GOOD_RECEPTION: 'good-reception',
    DISPOSAL_BALANCES: 'disposal-balances',
    RETURN_DISPATCHES: 'return-dispatches',
};

export const SECTION_CONFIG = {
    [SECTIONS.PRICE_LIST]: {
        path: '/admin/price-list',
        label: 'Общий прайс-лист',
        allowedRoles: [ROLES.ADMIN],
    },
    [SECTIONS.IMPORT_ORDERS]: {
        path: '/admin/import-orders',
        label: 'Импорт заказов',
        allowedRoles: [ROLES.ADMIN, ROLES.MANAGER],
    },
    [SECTIONS.BLACK_LIST]: {
        path: '/admin/black-list',
        label: 'Черный список',
        allowedRoles: [ROLES.ADMIN, ROLES.MANAGER],
    },
    [SECTIONS.ORDERS_PAGE]: {
        path: '/admin/orders-page',
        label: 'Заказы',
        allowedRoles: [ROLES.ADMIN, ROLES.MANAGER],
    },
    [SECTIONS.REFUND_REQUESTS_SUPPLIER]: {
        path: '/admin/refund-requests-supplier',
        label: 'Возвраты supplier',
        allowedRoles: [ROLES.ADMIN, ROLES.MANAGER],
    },
    [SECTIONS.REFUND_REQUESTS_BUYER]: {
        path: '/admin/refund-requests-buyer',
        label: 'Возвраты buyer',
        allowedRoles: [ROLES.ADMIN, ROLES.MANAGER],
    },
    [SECTIONS.TRANSACTIONS]: {
        path: '/admin/transactions',
        label: 'Транзакции',
        allowedRoles: [ROLES.ADMIN],
    },
    [SECTIONS.GOOD_RECEPTION]: {
        path: '/admin/good-reception',
        label: 'Приём товара',
        allowedRoles: [ROLES.ADMIN, ROLES.MANAGER, ROLES.WAREHOUSEMAN],
    },
    [SECTIONS.DISPOSAL_BALANCES]: {
        path: '/admin/disposal-balances',
        label: 'Выдача остатков',
        allowedRoles: [ROLES.ADMIN, ROLES.MANAGER, ROLES.WAREHOUSEMAN],
    },
    [SECTIONS.RETURN_DISPATCHES]: {
        path: '/admin/return-dispatches',
        label: 'Выдача возвратов',
        allowedRoles: [ROLES.ADMIN, ROLES.MANAGER],
    },
};

export const MENU_GROUPS = [
    [SECTIONS.PRICE_LIST, SECTIONS.IMPORT_ORDERS, SECTIONS.BLACK_LIST],
    [SECTIONS.ORDERS_PAGE, SECTIONS.REFUND_REQUESTS_SUPPLIER, SECTIONS.REFUND_REQUESTS_BUYER, SECTIONS.TRANSACTIONS],
    [SECTIONS.GOOD_RECEPTION, SECTIONS.DISPOSAL_BALANCES, SECTIONS.RETURN_DISPATCHES],
];

export function hasAccessToSection(role, section) {
    if (!role || !section) return false;
    const config = SECTION_CONFIG[section];
    if (!config) return false;
    return config.allowedRoles.includes(role);
}

export function getAccessibleMenuGroups(role) {
    if (!role) return [];
    
    return MENU_GROUPS
        .map(group => 
            group
                .filter(section => hasAccessToSection(role, section))
                .map(section => ({
                    section,
                    ...SECTION_CONFIG[section],
                }))
        )
        .filter(group => group.length > 0);
}

export function getDefaultPath(role) {
    switch (role) {
        case ROLES.ADMIN:
            return '/admin/price-list';
        case ROLES.MANAGER:
            return '/admin/orders-page';
        case ROLES.WAREHOUSEMAN:
            return '/admin/good-reception';
        default:
            return '/admin/good-reception';
    }
}

export function getRoleDisplayName(role) {
    switch (role) {
        case ROLES.ADMIN:
            return 'Администратор';
        case ROLES.MANAGER:
            return 'Менеджер';
        case ROLES.WAREHOUSEMAN:
            return 'Кладовщик';
        default:
            return role || 'Неизвестная роль';
    }
}
